export default __webpack_public_path__ + "static/hdfs-b956b35b168e073f63707a4e7a955fce.png";